import type { FC } from "react";

type Props = {
  greeting: string;
};

const ProfileGreeting: FC<Props> = ({ greeting }) => (
  <div className="mb-1 rounded-lg bg-muted p-2 text-sm">{greeting}</div>
);

export default ProfileGreeting;
